import { ShieldCheck, MapPin, Siren, BadgeCheck } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Licensed & Insured Officers" },
  { icon: MapPin, label: "Live GPS Tracking" },
  { icon: Siren, label: "One-Tap SOS" },
  { icon: BadgeCheck, label: "Background-Checked" },
];

const words = ["VETTED", "LICENSED", "SECURE", "ON-DEMAND", "INSURED", "PROTECTED"];

export const TrustMarquee = () => {
  return (
    <section className="relative border-y border-[#1E293B] bg-[#0F172A]/40">
      {/* trust icons */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-7 grid grid-cols-2 md:grid-cols-4 gap-5">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3" data-testid="trust-item">
            <div className="w-9 h-9 rounded-[10px] bg-[#292414] flex items-center justify-center shrink-0">
              <it.icon className="w-4.5 h-4.5 text-[#D4AF37]" />
            </div>
            <span className="font-body text-sm text-[#CBD5E1] leading-tight">{it.label}</span>
          </div>
        ))}
      </div>

      {/* slow editorial marquee */}
      <div className="border-t border-[#1E293B] overflow-hidden py-4">
        <div className="marquee-track">
          {[0, 1].map((rep) => (
            <div key={rep} className="flex items-center shrink-0" aria-hidden={rep === 1}>
              {words.map((w) => (
                <span key={w + rep} className="flex items-center">
                  <span className="font-head text-sm tracking-[0.28em] text-[#94A3B8] px-6">{w}</span>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
